import React from 'react';

import {skipToken} from '@reduxjs/toolkit/query';

import {ECurrencySymbol} from '@edna/utils';

import {ELicensePeriod} from 'src/containers/Licenses/definitions';

import {ELicenseLabelType, TTariffDetailFullInfo} from '../TariffsCatalog';
import {useGetCatalogTariffLicenseQuery} from './api';
import {TLicenseInfo} from './definitions';
import {getPrice} from './utils';

type TProps = {
  tariffCatalogId?: number;
  licenseDetailId?: number;
  license?: TTariffDetailFullInfo;
  skip?: boolean;
};

export const useLicenseInfo = ({
  tariffCatalogId,
  licenseDetailId,
  license: licenseProp,
  skip,
}: TProps): TLicenseInfo => {
  const {data: detail} = useGetCatalogTariffLicenseQuery(
    tariffCatalogId && licenseDetailId
      ? {tariffId: tariffCatalogId, licenseId: licenseDetailId}
      : skipToken,
    {skip: !licenseDetailId || !!licenseProp || skip},
  );

  const license = licenseProp ?? detail;

  const licenseInfo = React.useMemo(
    () => ({
      period: license?.data?.periodMonths === 12 ? ELicensePeriod.YEAR : ELicensePeriod.MONTH,
      licensePrice: getPrice(ELicenseLabelType.LICENSE, license?.pricingDetails),
      // WhatsApp
      connectionFee: getPrice(ELicenseLabelType.CONNECTION_FEE, license?.pricingDetails),
      amauPrice: getPrice(ELicenseLabelType.AMAU, license?.pricingDetails),
      mauCount: license?.data?.mauCount,
      // Viber
      packagePrice: getPrice(ELicenseLabelType.PACKAGE, license?.pricingDetails),
    }),
    [license?.id],
  );

  const currency = React.useMemo(
    () => (license?.currency ? ECurrencySymbol[license.currency] : null),
    [license?.currency],
  );

  return {...licenseInfo, currency};
};
